import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
const styles = {
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    width:"100%",
    padding: 13,
  },
  bold:{
      fontWeight:"bold"
  },
  margin:{
      marginBottom:10
  }
};

const ContactDetails = props => {
    const { classes } = props;
  return (
    <Grid container>
      <Grid item className={classes.border}>
        { props.contactInfo ? (
          props.contactInfo.sections.map((element, index) => (
          <React.Fragment key={index}>
            <Typography variant="subtitle1" className={classes.bold}>{element.heading}</Typography>
            <Typography variant="subtitle1" className={classes.margin}>
              <div
                dangerouslySetInnerHTML={{
                  __html: element.content
                }}
              />
            </Typography>
          </React.Fragment>
        ))) : (
          <Grid item xs={12} className={classes.border}><Typography variant="subtitle1">No Contract to Display</Typography></Grid>
        )}
      </Grid>
    </Grid>
  );
};

ContactDetails.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ContactDetails);
